module.exports = __webpack_public_path__ + "img/ExternalLink.284612ff.svg";